import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PrintViewLoan from "./PrintViewLoan";
import { change_Lang } from "../../actions/Helper_action";
import { getLoanRecipe } from "../../actions_agent/Invoice_action";

export class Print_ViewLoan extends Component {
 componentDidMount() {
  this.props.getLoanRecipe(
   this.props.match.params.id,
   this.props.match.params.index
  );
 }
 render() {
  const { viewLoanRecipe, lang, change_Lang, getLoanRecipe, user } = this.props;
  return (
   <Fragment>
    <div className="container-fluid">
     <PrintViewLoan
      viewLoanRecipe={viewLoanRecipe}
      lang={lang}
      change_Lang={change_Lang}
      getLoanRecipe={getLoanRecipe}
      user={user}
      invoiceNumber={this.props.match.params.index}
     />
    </div>
   </Fragment>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  viewLoanRecipe: state.Invoice_Reducer.viewLoanRecipe,
  user: state.AuthReducer.user,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
  getLoanRecipe: (id, index) => dispatch(getLoanRecipe(id, index)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(Print_ViewLoan);
